import { Control, Controller } from "react-hook-form";
import { AgendaCompany } from "../../graphql/API";
import React from "react";

export type IEditableCompanyField = 'name' | 'address' | 'phoneNumber';
export type IEditableCompany = Pick<AgendaCompany, IEditableCompanyField>;

interface ICustomInput {
    label: string;
    multiline?: boolean;
    control: Control<IEditableCompany, object>;
    name: IEditableCompanyField;
    rules?: object;
    startPlaceholder: string;
    stopPlaceholder: string;
}

const styles = {
    inputContainer: {
        marginBottom: "1rem",
        width: "100%",
    },
    label: {
        display: "block",
        fontWeight: 600,
        marginBottom: "0.5rem"
    },
    input: {
        width: "100%",
        padding: "0.5rem",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "1rem"
    },
    errorInput: {
        border: "1px solid red"
    },
    error: {
        color: "red",
        fontSize: "0.875rem",
        marginTop: "0.25rem"
    }
} as const;

const CustomInput = ({ control, name, label, rules = {}, multiline = false, startPlaceholder = "Enter your ", stopPlaceholder = "" }: ICustomInput) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
                <div style={styles.inputContainer}>
                    <label style={styles.label}>{label}</label>
                    {
                        multiline ? (
                            <textarea
                                value={value ?? ''}
                                onChange={onChange}
                                // onBlur={onBlur}
                                // onChange={e => onChange(e.target.value)}
                                // onBlur={e => onBlur(e)} 
                                placeholder={`${startPlaceholder}${label}${stopPlaceholder}`}
                                style={{
                                    ...styles.input,
                                    ...(error ? styles.errorInput : {})
                                }}
                                rows={4}
                            />
                        ) : (
                            <input
                                type="text"
                                value={value ?? ''}
                                onChange={onChange}
                                // onBlur={onBlur}
                                // onChange={e => onChange(e.target.value)}
                                // onBlur={e => onBlur()}
                                placeholder={`${startPlaceholder}${label}${stopPlaceholder}`}
                                style={{
                                    ...styles.input,
                                    ...(error ? styles.errorInput : {})
                                }}
                            />
                        )
                    }
                    {error && <div style={styles.error}>{error.message || error.type}</div>}
                </div>
            )}
        />
    );
};

export default CustomInput;
